import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, typography, typeface, getResetByTag, utilityStyles } from './../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("font-family:", typeface.typefaceBase, ";font-weight:", typography.typographyFontWeightNormal, ";em{font-style:normal;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var variantStyles = function variantStyles(_ref22) {
  var isInverse = _ref22.isInverse,
    variant = _ref22.variant;
  var variantColors = {
    caution: {
      "default": colors.yellow_800,
      inverse: colors.yellow_500
    },
    community: {
      "default": colors.coral_700,
      inverse: colors.coral_300
    },
    critical: {
      "default": colors.red_500,
      inverse: colors.red_400
    },
    dark: {
      "default": colors.navy_500,
      inverse: colors.lightBlue_100
    },
    darker: {
      "default": colors.black,
      inverse: colors.white
    },
    "default": {
      "default": colors.coolGray_900,
      inverse: colors.white
    },
    extraLight: {
      "default": colors.coolGray_700,
      inverse: colors.coolGray_500
    },
    information: {
      "default": colors.blue_500,
      inverse: colors.lightBlue_500
    },
    light: {
      "default": colors.gray_800,
      inverse: colors.gray_300
    },
    protection: {
      "default": colors.purple_700,
      inverse: colors.purple_300
    },
    success: {
      "default": colors.green_700,
      inverse: colors.green_300
    }
  };
  variantColors.brand = variantColors.information;
  if (variantColors[variant]) {
    return /*#__PURE__*/css("color:", variantColors[variant][isInverse ? 'inverse' : 'default'], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
  }
};
var _ref19 = process.env.NODE_ENV === "production" ? {
  name: "hex9mj",
  styles: "list-style:decimal"
} : {
  name: "13ef5bo-listStyles",
  styles: "list-style:decimal;label:listStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref20 = process.env.NODE_ENV === "production" ? {
  name: "1rf7nkz",
  styles: "li{list-style:none;}"
} : {
  name: "1wdj6p3-listStyles",
  styles: "li{list-style:none;};label:listStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref21 = process.env.NODE_ENV === "production" ? {
  name: "ah7wtd",
  styles: "li{position:relative;list-style:disc;}"
} : {
  name: "1fcvtpt-listStyles",
  styles: "li{position:relative;list-style:disc;};label:listStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var listStyles = function listStyles(_ref23) {
  var element = _ref23.element,
    hasBullets = _ref23.hasBullets;
  if (hasBullets && element === 'ul') {
    return _ref21;
  } else if (!hasBullets && element === 'ul') {
    return _ref20;
  } else if (hasBullets && element === 'ol') {
    return _ref19;
  }
};
var emphasisStyles = function emphasisStyles(_ref24) {
  var isInverse = _ref24.isInverse,
    emphasis = _ref24.emphasis;
  var emphasisColors = {
    caution: {
      "default": colors.yellow_700,
      inverse: colors.yellow_500
    },
    community: {
      "default": colors.coral_700,
      inverse: colors.coral_300
    },
    critical: {
      "default": colors.red_500,
      inverse: colors.red_400
    },
    information: {
      "default": colors.blue_500,
      inverse: colors.lightBlue_500
    },
    protection: {
      "default": colors.purple_700,
      inverse: colors.purple_300
    },
    success: {
      "default": colors.green_700,
      inverse: colors.green_300
    }
  };
  emphasisColors.brand = emphasisColors.information;
  return /*#__PURE__*/css("em{color:", (emphasisColors[emphasis] || {})[isInverse ? 'inverse' : 'default'], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:emphasisStyles;"));
};
var _ref16 = process.env.NODE_ENV === "production" ? {
  name: "2qga7i",
  styles: "text-align:right"
} : {
  name: "1r5lgvf-alignStyles",
  styles: "text-align:right;label:alignStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref17 = process.env.NODE_ENV === "production" ? {
  name: "1azakc",
  styles: "text-align:center"
} : {
  name: "1obvcx-alignStyles",
  styles: "text-align:center;label:alignStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref18 = process.env.NODE_ENV === "production" ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : {
  name: "qb407f-alignStyles",
  styles: "text-align:left;label:alignStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var alignStyles = function alignStyles(_ref25) {
  var align = _ref25.align;
  switch (align) {
    case 'left':
      return _ref18;
    case 'center':
      return _ref17;
    case 'right':
      return _ref16;
  }
};
var weightStyles = function weightStyles(_ref26) {
  var weight = _ref26.weight;
  switch (weight) {
    case 'thin':
      return /*#__PURE__*/css("font-weight:", typography.typographyFontWeightLight, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:weightStyles;"));
    case 'normal':
      return /*#__PURE__*/css("font-weight:", typography.typographyFontWeightNormal, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:weightStyles;"));
    case 'semibold':
      return /*#__PURE__*/css("font-weight:", typography.typographyFontWeightSemiBold, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:weightStyles;"));
    case 'bold':
      return /*#__PURE__*/css("font-weight:", typography.typographyFontWeightBold, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:weightStyles;"));
  }
};
var _ref14 = process.env.NODE_ENV === "production" ? {
  name: "1rcj98u",
  styles: "text-decoration:line-through"
} : {
  name: "1hjbzj2-decorationStyles",
  styles: "text-decoration:line-through;label:decorationStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref15 = process.env.NODE_ENV === "production" ? {
  name: "1wbll7q",
  styles: "text-decoration:underline"
} : {
  name: "1r7l9zi-decorationStyles",
  styles: "text-decoration:underline;label:decorationStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var decorationStyles = function decorationStyles(_ref27) {
  var decoration = _ref27.decoration;
  switch (decoration) {
    case 'underline':
      return _ref15;
    case 'strike':
      return _ref14;
  }
};
var _ref10 = process.env.NODE_ENV === "production" ? {
  name: "kxbue8",
  styles: "text-transform:none"
} : {
  name: "11ayhbz-transformStyles",
  styles: "text-transform:none;label:transformStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref11 = process.env.NODE_ENV === "production" ? {
  name: "kff9ir",
  styles: "text-transform:capitalize"
} : {
  name: "5w8kvc-transformStyles",
  styles: "text-transform:capitalize;label:transformStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref12 = process.env.NODE_ENV === "production" ? {
  name: "1tq8czj",
  styles: "text-transform:lowercase"
} : {
  name: "2vy9jk-transformStyles",
  styles: "text-transform:lowercase;label:transformStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref13 = process.env.NODE_ENV === "production" ? {
  name: "50zrmy",
  styles: "text-transform:uppercase"
} : {
  name: "vlue2z-transformStyles",
  styles: "text-transform:uppercase;label:transformStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var transformStyles = function transformStyles(_ref28) {
  var transform = _ref28.transform;
  switch (transform) {
    case 'uppercase':
      return _ref13;
    case 'lowercase':
      return _ref12;
    case 'capitalize':
      return _ref11;
    case 'none':
      return _ref10;
  }
};
var lineHeightStyles = function lineHeightStyles(_ref29) {
  var lineHeight = _ref29.lineHeight;
  switch (lineHeight) {
    case 'xs':
      return /*#__PURE__*/css("line-height:", typography.typographyLineHeightXs, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:lineHeightStyles;"));
    case 'sm':
      return /*#__PURE__*/css("line-height:", typography.typographyLineHeightSm, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:lineHeightStyles;"));
    case 'md':
      return /*#__PURE__*/css("line-height:", typography.typographyLineHeightMd, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:lineHeightStyles;"));
    case 'lg':
      return /*#__PURE__*/css("line-height:", typography.typographyLineHeightLg, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:lineHeightStyles;"));
  }
};
var _ref9 = process.env.NODE_ENV === "production" ? {
  name: "1h52dri",
  styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
} : {
  name: "1iwrst6-truncatedStyle",
  styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap;label:truncatedStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var truncatedStyle = function truncatedStyle(_ref30) {
  var isTruncated = _ref30.isTruncated;
  if (isTruncated) return _ref9;
};
var _ref8 = process.env.NODE_ENV === "production" ? {
  name: "1jwcxx3",
  styles: "font-style:italic"
} : {
  name: "vapjid-italicStyle",
  styles: "font-style:italic;label:italicStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var italicStyle = function italicStyle(_ref31) {
  var isItalic = _ref31.isItalic;
  if (isItalic) return _ref8;
};
var _ref7 = process.env.NODE_ENV === "production" ? {
  name: "1u4hpl4",
  styles: "display:inline"
} : {
  name: "1lgsaru-inlineStyle",
  styles: "display:inline;label:inlineStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var inlineStyle = function inlineStyle(_ref32) {
  var isBlock = _ref32.isBlock;
  if (!isBlock) return _ref7;
};
var fontSizeStyles = function fontSizeStyles(_ref33) {
  var size = _ref33.size;
  var fontSizes = {
    '2xs': {
      "default": typography.typographyBodyMi
    },
    xs: {
      "default": typography.typographyBodyXs
    },
    sm: {
      "default": typography.typographyBodySm,
      mobile: typography.typographyBodyXs
    },
    md: {
      "default": typography.typographyBodyMd,
      mobile: typography.typographyBodySm
    },
    lg: {
      "default": typography.typographyBodyLg,
      mobile: typography.typographyBodyMd
    },
    xl: {
      "default": typography.typographyHeadingSm,
      mobile: typography.typographyBodyLg
    },
    '2xl': {
      "default": typography.typographyHeadingMd,
      mobile: typography.typographyHeadingSm
    },
    '3xl': {
      "default": typography.typographyHeadingLg,
      mobile: typography.typographyHeadingMd
    },
    '4xl': {
      "default": typography.typographyHeadingGi,
      mobile: typography.typographyHeadingLg
    },
    '5xl': {
      "default": typography.typographyDisplayXs,
      mobile: typography.typographyHeadingLg
    },
    '6xl': {
      "default": typography.typographyDisplaySm,
      mobile: typography.typographyHeadingXl
    },
    '7xl': {
      "default": typography.typographyDisplayMd,
      mobile: typography.typographyHeadingXl
    },
    '8xl': {
      "default": typography.typographyDisplayXl,
      mobile: typography.typographyHeadingGi
    }
  };
  fontSizes.s = fontSizes.sm;
  fontSizes.m = fontSizes.md;
  fontSizes.l = fontSizes.lg;
  if (fontSizes[size]) {
    var _fontSizes$size$mobil;
    return /*#__PURE__*/css("font-size:", fontSizes[size]["default"], ";@media (max-width: 768px){font-size:", (_fontSizes$size$mobil = fontSizes[size].mobile) !== null && _fontSizes$size$mobil !== void 0 ? _fontSizes$size$mobil : fontSizes[size]["default"], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:fontSizeStyles;"));
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1hizjpa",
  styles: "white-space:normal"
} : {
  name: "4drkqa-whiteSpaceStyles",
  styles: "white-space:normal;label:whiteSpaceStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "2attqf",
  styles: "white-space:break-spaces"
} : {
  name: "xrzo1h-whiteSpaceStyles",
  styles: "white-space:break-spaces;label:whiteSpaceStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "1l0p3iw",
  styles: "white-space:pre-line"
} : {
  name: "1a8s9sc-whiteSpaceStyles",
  styles: "white-space:pre-line;label:whiteSpaceStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "1089mxj",
  styles: "white-space:pre-wrap"
} : {
  name: "qe3xg1-whiteSpaceStyles",
  styles: "white-space:pre-wrap;label:whiteSpaceStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref5 = process.env.NODE_ENV === "production" ? {
  name: "o572a0",
  styles: "white-space:pre"
} : {
  name: "11ey83q-whiteSpaceStyles",
  styles: "white-space:pre;label:whiteSpaceStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref6 = process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "tzxzli-whiteSpaceStyles",
  styles: "white-space:nowrap;label:whiteSpaceStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var whiteSpaceStyles = function whiteSpaceStyles(_ref34) {
  var whiteSpace = _ref34.whiteSpace;
  switch (whiteSpace) {
    case 'nowrap':
      return _ref6;
    case 'pre':
      return _ref5;
    case 'pre-wrap':
      return _ref4;
    case 'pre-line':
      return _ref3;
    case 'break-spaces':
      return _ref2;
    case 'normal':
      return _ref;
  }
};
var resetStyles = getResetByTag('span');
var StyledType = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e143ve5p0"
} : {
  target: "e143ve5p0",
  label: "StyledType"
})(resetStyles, defaultStyles, variantStyles, emphasisStyles, alignStyles, weightStyles, decorationStyles, transformStyles, lineHeightStyles, truncatedStyle, italicStyle, fontSizeStyles, whiteSpaceStyles, inlineStyle, listStyles, utilityStyles);
export default StyledType;